
import { useState } from 'react';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const BlogNewsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success'>('idle');
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.15 });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;

    const mensaje = `Hola, me gustaría suscribirme al newsletter de Desguace Gavá.

📧 *Email:* ${email}

Por favor, añádanme a su lista de correo para recibir artículos y novedades. Gracias.`;

    const url = `https://wa.me/34932932913?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');

    setStatus('success');
    setEmail('');
  };

  return (
    <section className="py-20 px-6 lg:px-12 bg-white">
      <div ref={sectionRef} className="max-w-3xl mx-auto text-center">
        <div
          className={`w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6 transition-all duration-600 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
          }`}
        >
          <i className="ri-mail-send-line text-emerald-600 text-2xl"></i>
        </div>
        <h2
          className={`text-3xl font-bold text-gray-900 mb-4 transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Recibe Nuestros Artículos sobre <strong>Desguaces en Gavá</strong>
        </h2>
        <p
          className={`text-gray-500 mb-8 leading-relaxed transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Suscríbete y recibe consejos, novedades del sector y guías prácticas sobre venta de coches siniestrados, reciclaje de vehículos y normativas en Gavá directamente en tu correo.
        </p>

        {status === 'success' ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-6 inline-flex items-center space-x-3">
            <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
              <i className="ri-whatsapp-line text-emerald-600 text-xl"></i>
            </div>
            <p className="text-emerald-700 font-medium">¡Se ha enviado tu suscripción por WhatsApp!</p>
          </div>
        ) : (
          <form
            id="newsletter-blog-form"
            onSubmit={handleSubmit}
            className={`flex flex-col sm:flex-row gap-3 max-w-lg mx-auto transition-all duration-700 delay-300 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Tu correo electrónico"
              required
              className="flex-1 px-5 py-3.5 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-gray-50"
            />
            <button
              type="submit"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-3.5 rounded-lg font-semibold text-sm transition-all hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Suscribirme
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default BlogNewsletter;
